import {Container, Singleton} from "typescript-ioc";
import {Resource} from "@/model/ThingModel";
import StorageKey from "@/storage/StorageKey";
import BizStorage from './BizStorage';
import {LocalStorageWrapper} from "@/storage/StorageWrapper";

@Singleton
export default abstract class ResourceStorage extends BizStorage<Resource> {
    protected key = StorageKey.RESOURCE
}

class ResourceStorageImpl extends ResourceStorage {
    storage = Container.get(LocalStorageWrapper)
}

Container.bind(ResourceStorage).to(ResourceStorageImpl)
